import { MetalsTaskType } from '../enums/metals-task-type.enum';
import { PackUnitType } from '../enums/pack-unit-type.enum';

export function resolveMetalsPackUnitQuantity(
    quantity: number | null | undefined,
): number | null {
    if (Number.isInteger(quantity) && Number(quantity) > 0) {
        return Number(quantity);
    }
    return null;
}

export function resolveMetalsPackUnitType(
    type: string | null | undefined,
): PackUnitType {
    if (type && (Object.values(PackUnitType) as string[]).includes(type)) {
        return type as PackUnitType;
    }
    return PackUnitType.Box;
}

export function isMetalsPunchPressTaskType(type: string | null | undefined): boolean {
    return type === MetalsTaskType.TurretPunch || type === MetalsTaskType.Stamping;
}

export function metalsPackUnitPrintButtonLabel(
    quantity: number,
    unitType: PackUnitType | string | null | undefined,
): string {
    return `Print ${resolveMetalsPackUnitType(unitType)} label + record ${quantity} parts`;
}
